import {http} from "@/config/HttpClient";
import {Alert} from "@/addons/Alert";
import {materialStore} from "@/store/materialStore";
import {globalStore} from "@/store/globalStore";
import {AxiosResponse} from "axios";
import {DateTime} from 'luxon';
import {bincardStore} from "@/store/bincardStore";

export class BincardService{
    private static instance: BincardService;

    baseURL= `${process.env.VUE_APP_URL}`;

    public static getInstance(){
        return this.instance || (this.instance = new this());
    }

    bincardStore = bincardStore();
    globalStore = globalStore();

    public async index(data: any) {
        this.bincardStore.loading = true;
        await http.get("getMateriales", {params: data}).subscribe({
            next: (response) => {
                this.bincardStore.materialesListado = response.data.data;
                this.makePagination(response.data);
                this.bincardStore.loading = false;
            },
            error: (error) => {
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                this.bincardStore.loading = false;
            }
        })
    }


    public async showBincard(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.bincardStore.loading = true;
            http.get("binCardMaterial", {params: data}).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        this.bincardStore.bincard = response.data.bin
                        this.bincardStore.sumIngresos = response.data.sumIngresos
                        this.bincardStore.sumSalidas = response.data.sumSalidas
                        this.bincardStore.saldoInicial = response.data.saldoInicial
                        this.bincardStore.loading = false;
                    }
                },
                error: (error) => {
                    this.bincardStore.loading = false;
                    reject(error);
                }
            })
        });
    }

    public async showBindCardPeps(data: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.bincardStore.loading = true;
            http.get("binCardPepsMaterial", {params: data}).subscribe({
                next: (response: AxiosResponse) => {
                    if (response.data) {
                        this.bincardStore.bincard = response.data.bin
                        this.bincardStore.sumIngresos = response.data.sumIngresos
                        this.bincardStore.sumSalidas = response.data.sumSalidas
                        this.bincardStore.saldoInicial = response.data.saldoInicial
                        this.bincardStore.loading = false;
                    }
                },
                error: (error) => {
                    this.bincardStore.loading = false;
                    reject(error);
                }
            })
        });
    }



    makePagination(page: any) {
        this.bincardStore.pagination.per_page = page.per_page;
        this.bincardStore.pagination.current_page = page.current_page;
        this.bincardStore.pagination.last_page = page.last_page;
    }

}